import { FC } from 'react';

import Jumbotron from 'modules/common/components/Jumbotron';

import styles from './ProAward2023Content.module.scss';

import { proposalAwards, reveiwAwards } from './ProAward2023Data.json';
import ProAward2023ProCard from './ProAward2023ProCard';

const ProAward2023Content: FC = () => {
  const proAwardTitleImageUrl = '/static/images/pro-award-2023/title-mobile.svg';
  const proposalAawardIconImageUrl = '/static/images/pro-award-2023/icon-document.svg';
  const reviewAwardIconImageUrl = '/static/images/pro-award-2023/icon-comment.svg';

  return (
    <>
      <Jumbotron
        bgImg="/static/images/pro-award-2023/header-background.png"
        bgImgPosition="absolute"
      >
        <div className={styles['pro-award-title']}>
          <img
            alt="PRO AWARD 2023"
            data-test-id="pro-award-2023-title"
            src={proAwardTitleImageUrl}
          />
        </div>
      </Jumbotron>
      <div className={styles['content']}>
        <div className={styles['section']}>
          <pre className={styles['intro-content']}>
            2022年1月から12月の期間で、2つのカテゴリにおいて特に成果をあげた事業者を表彰するアワードです。
            <br />
            その道のプロフェッショナルである事業者の方を、ゼヒトモは敬意を込めて「プロ」とお呼びしています。
            <br />
            <br />
            ゼヒトモは、依頼者の「やりたい」を実現する場であると同時に、事業者である「プロ」がビジネスの幅を広げ、より成功するためのプラットフォームです。
            <br />
            これからも、プロの活躍の場を広げ、より自由で豊かな働き方とライフスタイルの実現を目指します。
            <br />
          </pre>
        </div>

        <div className={styles['section-blue']}>
          <img
            alt="ご提案賞"
            className={styles['award-info-icon']}
            src={proposalAawardIconImageUrl}
          />
          <h2 className={styles['award-info-section-title']}>ご提案賞</h2>
          <pre className={styles['award-info-intro']}>
            ご要望に迅速に応えてくださることで
            <br />
            お客様の満足度も向上します。
            <br />
            依頼に対する提案数で選出しています。
            <br />
          </pre>
          <div className={styles['award-list-container']}>
            {proposalAwards.map(
              ({
                avatarUrl,
                commentMessage,
                jobTypeName,
                location,
                proName,
                profileUrl,
                websiteUrl,
              }) => (
                <ProAward2023ProCard
                  avatarUrl={avatarUrl}
                  commentMessage={commentMessage}
                  jobTypeName={jobTypeName}
                  key={`proposal_award_${proName}`}
                  location={location}
                  proName={proName}
                  profileUrl={profileUrl}
                  websiteUrl={websiteUrl}
                />
              )
            )}
          </div>

          <img alt="口コミ賞" className={styles['award-info-icon']} src={reviewAwardIconImageUrl} />
          <h2 className={styles['award-info-section-title']}>口コミ賞</h2>
          <pre className={styles['award-info-intro']}>
            サービスを選ぶ時に大切な要素と
            <br />
            なっているのが口コミです。
            <br />
            口コミ投稿数で選出しています。
            <br />
          </pre>
          <div className={styles['award-list-container']}>
            {reveiwAwards.map(
              ({
                avatarUrl,
                commentMessage,
                jobTypeName,
                location,
                proName,
                profileUrl,
                websiteUrl,
              }) => (
                <ProAward2023ProCard
                  avatarUrl={avatarUrl}
                  commentMessage={commentMessage}
                  jobTypeName={jobTypeName}
                  key={`comment_award_${proName}`}
                  location={location}
                  proName={proName}
                  profileUrl={profileUrl}
                  websiteUrl={websiteUrl}
                />
              )
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProAward2023Content;
